module.exports = __webpack_public_path__ + "img/mobile-mapping-header.1f029be0.jpg";